type TypeRemoveIndexFromArray = <T>(array: T[], idx: number) => void;

export const removeIndexFromArray: TypeRemoveIndexFromArray = <T>(
  array: T[],
  idx: number
) => {
  if (idx >= 0 && idx < array.length) {
    array.splice(idx, 1)
  }
}

export const scrollToTop = () => {
  window?.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
}

export const restoreScrollBehavior = () => {
  document.ontouchmove = null
  document.body.classList.remove('slider-being-dragged')
  const html = document.documentElement
  if (html.classList.contains('lock-scroll')) {
    html.classList.remove('lock-scroll')
  }
}

export const invertObject = (
  obj: Record<string, string>
): Record<string, string> => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[value] = key
    return acc
  }, {} as Record<string, string>)
}

export const arraysContainsSameValues = <T>(arr1: T[], arr2: T[]): boolean => {
  if (arr1.length !== arr2.length) return false
  const sortedArr1 = [...arr1].sort()
  const sortedArr2 = [...arr2].sort()
  return sortedArr1.every((value, index) => value === sortedArr2[index])
}
